import { render } from "./InfoTextHeading.vue?vue&type=template&id=57a2c21b&scoped=true"
import script from "./InfoTextHeading.vue?vue&type=script&lang=js"
export * from "./InfoTextHeading.vue?vue&type=script&lang=js"

import "./InfoTextHeading.vue?vue&type=style&index=0&id=57a2c21b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a2c21b"]])

export default __exports__